import React, { Component } from 'react';
import moment from 'moment'

import './GarminSummary.css';


class GarminSummary extends Component {
  render() {
    const userStats = this.props.userStats || {}
    const updated = userStats.untilStress || userStats.untilSleep
    return <div className='GarminSummary'>
      {!updated &&
        <div>データは同期されていません。Garmin Connectアプリから同期を行ってください。</div>}
      {updated &&
        <div>最後に確認した日時: {moment(new Date(updated)).fromNow()}</div>}
      {this.props.expired &&
        <div className='GarminSync'>
          Garminのデータが2日間以上同期されていません。
          <strong>Garmin Connectアプリ</strong>を起動してあなたの活動状態を確認してみましょう！
          <div>
            <img src='/hint/sync-garmin.png' alt='Sync Garmin' />
          </div>
        </div>}
    </div>
  }
}

export default GarminSummary;
